module.exports = __webpack_public_path__ + "img/thumbnail_CloudedLeopard_m_normal.12c70e2f.png";